module.exports = "/_next/static/images/Hero-lg@3x-b7e06ecc1a2a7007427ba7a95e75684b.webp";